// main.js
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './styles' // Import all styles from the styles directory
import axios from 'axios'
import 'swiper/swiper-bundle.css'
import { Vue3Toastify } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css' // Import Toastify styles

// Create the Vue application
const app = createApp(App)
const pinia = createPinia()

// Configure Axios as a global instance with default settings
const axiosInstance = axios.create({
    baseURL: 'http://localhost:8000/api', // Replace with your actual base API URL
    headers: {
        'Content-Type': 'application/json',
    }
})

// Optional: Set up interceptors for request and response handling
axiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('auth_token')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        // Perform actions before sending each request (e.g., add an auth token)
        return config
    },
    error => {
        // Handle request errors here
        return Promise.reject(error)
    }
)

axiosInstance.interceptors.response.use(
    response => {
        // Process the response as needed
        return response
    },
    error => {
        // Handle errors globally
        if (error.response && error.response.status === 401) {
            console.error("Unauthorized access - please log in.")
        }
        return Promise.reject(error)
    }
)

// Make the Axios instance available globally
app.config.globalProperties.$axios = axiosInstance
// Set a global variable
//app.config.globalProperties.$siteURL = 'http://localhost:8080/'
// Set the site URL dynamically from the environment variables
app.config.globalProperties.$siteURL = process.env.VUE_APP_SITE_URL || 'http://localhost:8080/';

// Add Pinia
app.use(pinia)

// Add Vue Router
app.use(router)

// Add Vue3 Toastify
app.use(Vue3Toastify, {
    autoClose: 3000, // Toast automatically closes after 3 seconds
})

// Mount the app
app.mount('#app')
